import "./App.css";

import { JsonSchemaBuilder } from "./components/json-schema-builder";

function App() {
  return (
    <div className="flex justify-center items-center my-16">
      <JsonSchemaBuilder />
    </div>
  );
}

export default App;
